<template>
  <div style="width: 1800px;">
    <table class="chart-table" style='border-collapse:collapse'>
      <thead>
        <tr class="title-text">
          <th rowspan="2" colspan="3" width="80" class="border-bottom border-right border-left">期号</th>
          <th rowspan="1" colspan="7" class="border-bottom border-right">开奖号码</th>
          <th colspan="3" rowspan="2" width="100" class="border-right border-bottom">色波</th>
          <th colspan="3" rowspan="2" width="100" class="border-right border-bottom">大小</th>
          <th colspan="3" rowspan="2" width="100" class="border-right border-bottom">单双</th>
          <th colspan="3" rowspan="2" width="100" class="border-right border-bottom">合大小</th>
          <th colspan="3" rowspan="2" width="100" class="border-right border-bottom">合单双</th>
          <th colspan="3" rowspan="2" width="100" class="border-right border-bottom">尾大小</th>
          <th colspan="3" rowspan="2" width="100" class="border-right border-bottom">生肖</th>
        </tr>
        <tr>
          <th v-for="(label, index) in lotteryNumbHead" :key="index" width="7%" class="border-bottom border-right">{{ label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 开奖号码 -->
          <td v-for="(num, nindex) in openNumbArr[index]" :key="nindex" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1, 'bgcolor': currPlay === nindex}">
            <i class="pdd" :class="mixinFindNumbColor(num)">{{ num }}</i><span class="navTxt">{{mixinFindNumbAnimal(num,getAnimalList(item.theoryDrawingDate))}}</span>
          </td>
          <!-- 色波 -->
          <td colspan="3" class="ball-none border-right" :class="`block-${mixinFindNumbColor(openNumbArr[index][currPlay])}`">
            {{ mixinFindNumbColor(openNumbArr[index][currPlay]) === 'blue' ? '蓝' : mixinFindNumbColor(openNumbArr[index][currPlay]) === 'red' ? '红' : '绿' }}
          </td>
          <!-- 大小 -->
          <td v-if="currPlay === 6" colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            {{ openNumbArr[index][currPlay] == 49 ? '和' : openNumbArr[index][currPlay] >= 25 ? '大' : '小' }}
          </td>
          <td v-else colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            {{ openNumbArr[index][currPlay] >= 25 ? '大' : '小' }}
          </td>
          <!-- 单双 -->
          <td v-if="currPlay === 6" colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            {{ openNumbArr[index][currPlay] == 49 ? '和' : openNumbArr[index][currPlay] % 2 == 0 ? '双' : '单' }}
          </td>
          <td v-else colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            {{ openNumbArr[index][currPlay] % 2 == 0 ? '双' : '单' }}
          </td>
          <!-- 合大小 -->
          <td colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            {{ Math.floor((Number(openNumbArr[index][currPlay])) / 10) + (Number(openNumbArr[index][currPlay]) % 10) <= 6 ? '合小' : '合大' }}
          </td>
          <!-- 合单双 -->
          <td colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
             {{sum(openNumbArr[index])%2==0?"合双":"合单"}}
          </td>
          <!-- 尾大小 -->
          <td v-if="currPlay === 6" colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            {{ openNumbArr[index][currPlay] == 49 ? '和' : (Number(openNumbArr[index][currPlay]) % 10) <= 4 ? '尾小' : '尾大' }}
          </td>
          <td v-else colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            {{ (Number(openNumbArr[index][currPlay]) % 10) <= 4 ? '尾小' : '尾大' }}
          </td>
          <!-- 生肖 -->
          <td colspan="3" class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            {{ mixinFindNumbAnimal(openNumbArr[index][currPlay], getAnimalList(item.theoryDrawingDate)) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import mix from "../../../mixins/trendChart.mixins.vue";
import betLhcMixins from "~/mixins/lhc.mixins";
export default {
  name: 'LhcChart',
  mixins: [mix, betLhcMixins],
  props: {
    currPlay: {
      type: [Number,String],
      default: 6
    }
  },
  methods: {
    getAnimalList(date) {
      return this.getCurrYearAnimal(new Date(date));
    },
    sum(arr) {
    return arr.reduce(function(prev, curr, idx, arr){
        return Number(prev) + Number(curr);
    });
}
  }
}
</script>

<style>

</style>